module.exports = __webpack_public_path__ + "media/images/icons/icon_arrow_up_black-3419e4a8c3a23a963b54c3dc0f729207.svg";